module.exports = __webpack_public_path__ + "img/v5plus.d3f8dea7.svg";